import Reflux from 'reflux'
import axios from 'axios'
import _ from 'lodash'

import IngredientsActions from '~/actions/ingredients.js'

import apiUtils from '../helper/api.js'


export default class extends Reflux.Store {
	constructor() {
		super()

		this.listenables = IngredientsActions

		this.state = {
			ingredients: [],
			ingredientFilterLetter: '',
			showIngredientsModal: false
		}

		// hydrate as soon as initialized
		this.reload()
	}

	reload() {
		axios.get(`${apiUtils.getApiURL()}/ingredients?filter[where][isActive]=1`)
			.then(
				(response) => {
					let ingredients = response.data

					ingredients = _.forEach(
						ingredients,
						(theIngredient) => {
							const newIngredient = theIngredient

							newIngredient.capitalized = theIngredient.ingredient.toUpperCase()
							newIngredient.firstLetter = newIngredient.capitalized.substring(0, 1)

							return newIngredient
						}
					)

					this.setState({ ingredients: _.sortBy(ingredients, 'capitalized') })
				}
			)
	}

	setFilterLetter(ingredientFilterLetter) {
		this.setState({ ingredientFilterLetter })
	}

	showModal() {
		this.setState({ showIngredientsModal: true })
	}

	hideModal() {
		this.setState({ showIngredientsModal: false })
	}
}



// WEBPACK FOOTER //
// ./src/stores/ingredients.js